import { render, staticRenderFns } from "./app.vue?vue&type=template&id=48e8f15d&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports